import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
import * as bootstrap from "bootstrap";
pdfMake.vfs = pdfFonts.vfs;


const GameMatchmaking = () => {
    const resetMM = () => {
        document.querySelectorAll(".step").forEach(el => {
            el.classList.remove("active", "completed");
        });

        document.getElementById("mmStep1").classList.add("active");

        document.getElementById("mmStep1Content").style.display = "block";
        document.getElementById("mmStep2Content").style.display = "none";
        document.getElementById("mmStep3Content").style.display = "none";
        document.getElementById("mmStep4Content").style.display = "none";

        document.getElementById("oppTeamName").innerText = "";
        document.getElementById("oppClubName").innerText = "";
    };

    window.selectOpp = (team, club) => {
        document.getElementById("oppTeamName").innerText = team;
        document.getElementById("oppClubName").innerText = club;

        document.getElementById("mmStep1").classList.remove("active");
        document.getElementById("mmStep1").classList.add("completed");
        document.getElementById("mmStep2").classList.add("active");

        document.getElementById("mmStep1Content").style.display = "none";
        document.getElementById("mmStep2Content").style.display = "block";
    };

    window.backToStep1 = () => {
        document.getElementById("mmStep2").classList.remove("active", "completed");
        document.getElementById("mmStep1").classList.add("active");

        document.getElementById("mmStep2Content").style.display = "none";
        document.getElementById("mmStep1Content").style.display = "block";
    };

    window.backToStep2 = () => {
        document.getElementById("mmStep3").classList.remove("active", "completed");
        document.getElementById("mmStep2").classList.add("active");

        document.getElementById("mmStep3Content").style.display = "none";
        document.getElementById("mmStep2Content").style.display = "block";
    };

    window.backToStep3 = () => {
        document.getElementById("mmStep4").classList.remove("active", "completed");
        document.getElementById("mmStep3").classList.add("active");

        document.getElementById("mmStep4Content").style.display = "none";
        document.getElementById("mmStep3Content").style.display = "block";
    };

    window.goToStep3 = () => {
        document.getElementById("mmStep2").classList.remove("active");
        document.getElementById("mmStep2").classList.add("completed");
        document.getElementById("mmStep3").classList.add("active");

        document.getElementById("mmStep2Content").style.display = "none";
        document.getElementById("mmStep3Content").style.display = "block";
    };

    window.goToStep4 = () => {
        document.getElementById("mmStep3").classList.remove("active");
        document.getElementById("mmStep3").classList.add("completed");
        document.getElementById("mmStep4").classList.add("active");

        document.getElementById("mmStep3Content").style.display = "none";
        document.getElementById("mmStep4Content").style.display = "block";
    };

    const pendingRef = useRef(null);
    const matchedRef = useRef(null);
    const canceledRef = useRef(null);

    const openCancelModal = (e) => {
        e.preventDefault();

        const modal = new bootstrap.Modal(
            document.getElementById("cancelModal")
        );
        modal.show();
    };

    const openMatchmaking = (e) => {
        e.preventDefault();

        const modal = new bootstrap.Modal(
            document.getElementById("matchmakingModal")
        );
        modal.show();

        resetMM();
    };

    useEffect(() => {
        window.JSZip = jszip;

        [pendingRef, matchedRef, canceledRef].forEach((ref) => {
            if (ref.current) {
                $(ref.current).DataTable({
                    pageLength: 5,
                    lengthChange: false,
                    destroy: true,
                    dom:
                        "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                    buttons: ["copy", "excel", "pdf", "print"],
                });
            }
        });

        return () => {
            [pendingRef, matchedRef, canceledRef].forEach((ref) => {
                if (ref.current) $(ref.current).DataTable().destroy();
            });
        };
    }, []);

    const handleAction = (id) => {
        alert(`Action clicked for ${id}`);
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Game Matchmaking</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Game Matchmaking</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            {/* filters */}
                            <div className="row g-3 mb-4 filters-main">
                                <div className="col"><label>Search requests...</label><input className="form-control" placeholder="ID, club, team" /></div>
                                <div className="col"><label>All Seasons</label><select className="form-select">
                                    <option>Spring 2026</option>
                                    <option>Fall 2025</option>
                                </select></div>
                                <div className="col"><label>All Age Groups</label><select className="form-select">
                                    <option>U-17</option>
                                    <option>U-16</option>
                                    <option>U-15</option>
                                    <option>U-14</option>
                                </select></div>
                                <div className="col"><label>Status</label><select className="form-select">
                                    <option>Pending</option>
                                    <option>Matched</option>
                                    <option>Cancelled</option>
                                </select></div>
                                <div className="col d-flex gap-2 align-items-end filter-bttn"><button className="btn btn-outline-secondary">Reset</button><button className="btn btn-primary">Apply</button></div>
                            </div>
                            {/* tabs: Pending / Matched / Canceled (exact wording) */}
                            <ul className="nav nav-tabs nav-primary mb-3">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#pending">Pending</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#matched">Matched</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#canceled">Canceled</a>
                                </li>
                            </ul>
                            <div className="tab-content">
                                {/* pending tab with sample row that triggers modals */}
                                <div className="tab-pane fade show active" id="pending">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <table className="table table-striped table-bordered dataTable no-footer" id="table1" ref={pendingRef}>
                                        <thead>
                                            <tr>
                                                <th>Request ID</th>
                                                <th>Club Director</th>
                                                <th>Club</th>
                                                <th>Team Name</th>
                                                <th>Season</th>
                                                <th>Age Group</th>
                                                <th>Submitted On</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Row 1: Pending */}
                                            <tr>
                                                <td>#REQ-001</td>
                                                <td>
                                                    <span>Alex Morgan</span>
                                                </td>
                                                <td>Riverside FC</td>
                                                <td>Eagles U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 18, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 2: Pending */}
                                            <tr>
                                                <td>#REQ-002</td>
                                                <td>
                                                    <span>Michael Chen</span>
                                                </td>
                                                <td>Metro United</td>
                                                <td>Tigers U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 19, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 3: Pending */}
                                            <tr>
                                                <td>#REQ-003</td>
                                                <td>
                                                    <span>Jessica Rodriguez</span>
                                                </td>
                                                <td>Eagle Sports</td>
                                                <td>Bears U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 20, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 4: Pending */}
                                            <tr>
                                                <td>#REQ-004</td>
                                                <td>
                                                    <span>Sarah Williams</span>
                                                </td>
                                                <td>Panthers CC</td>
                                                <td>Panthers U-10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 24, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-cancelled">Cancelled</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 5: Pending */}
                                            <tr>
                                                <td>#REQ-005</td>
                                                <td>
                                                    <span>David Kim</span>
                                                </td>
                                                <td>North Stars SC</td>
                                                <td>Rockets U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 25, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="tab-pane fade" id="matched">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered dataTable no-footer" id="table3" ref={matchedRef}>
                                            <thead>
                                                <tr>
                                                    <th>Request ID</th>
                                                    <th>Club Director</th>
                                                    <th>Club</th>
                                                    <th>Team Name</th>
                                                    <th>Season</th>
                                                    <th>Age Group</th>
                                                    <th>Opponent Team</th>
                                                    <th>Submitted On</th>
                                                    <th>Payment Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Row 1: Matched */}
                                                <tr>
                                                    <td>#REQ-001</td>
                                                    <td><span>Alex Morgan</span></td>
                                                    <td>Riverside FC</td>
                                                    <td>Eagles U10</td>
                                                    <td>Spring 2026</td>
                                                    <td>U-10</td>
                                                    <td>Tigers U10 (Metro United)</td>
                                                    <td>Feb 18, 2026</td>
                                                    <td>
                                                        <span className="badge bg-soft-success">Paid</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={openMatchmaking}>
                                                                    <i className="bx bx-check-circle" data-bs-toggle="tooltip" title="MatchMaking" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Row 2: Matched */}
                                                <tr>
                                                    <td>#REQ-002</td>
                                                    <td><span>Michael Chen</span></td>
                                                    <td>Metro United</td>
                                                    <td>Tigers U10</td>
                                                    <td>Spring 2026</td>
                                                    <td>U-10</td>
                                                    <td>Eagles U10 (Riverside FC)</td>
                                                    <td>Feb 19, 2026</td>
                                                    <td>
                                                        <span className="badge bg-soft-warning">Unpaid</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={openMatchmaking}>
                                                                    <i className="bx bx-check-circle" data-bs-toggle="tooltip" title="MatchMaking" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Row 3: Pending */}
                                                <tr>
                                                    <td>#REQ-003</td>
                                                    <td><span>Jessica Rodriguez</span></td>
                                                    <td>Eagle Sports</td>
                                                    <td>Bears U10</td>
                                                    <td>Spring 2026</td>
                                                    <td>U-10</td>
                                                    <td>Panthers U-10 (Panthers CC)</td>
                                                    <td>Feb 20, 2026</td>
                                                    <td>
                                                        <span className="badge bg-soft-pending">Pending</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={openMatchmaking}>
                                                                    <i className="bx bx-check-circle" data-bs-toggle="tooltip" title="MatchMaking" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Row 4: Cancelled */}
                                                <tr>
                                                    <td>#REQ-004</td>
                                                    <td><span>Sarah Williams</span></td>
                                                    <td>Panthers CC</td>
                                                    <td>Panthers U-10</td>
                                                    <td>Spring 2026</td>
                                                    <td>U-10</td>
                                                    <td>Bears U10 (Eagle Sports)</td>
                                                    <td>Feb 24, 2026</td>
                                                    <td>
                                                        <span className="badge bg-soft-cancelled">Cancelled</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={openMatchmaking}>
                                                                    <i className="bx bx-check-circle" data-bs-toggle="tooltip" title="MatchMaking" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Row 5: Pending */}
                                                <tr>
                                                    <td>#REQ-005</td>
                                                    <td><span>David Kim</span></td>
                                                    <td>North Stars SC</td>
                                                    <td>Rockets U10</td>
                                                    <td>Spring 2026</td>
                                                    <td>U-10</td>
                                                    <td>Sharks U10 (City Youth FC)</td>
                                                    <td>Feb 25, 2026</td>
                                                    <td>
                                                        <span className="badge bg-soft-pending">Pending</span>
                                                    </td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li>
                                                                <a href="#" onClick={openMatchmaking}>
                                                                    <i className="bx bx-check-circle" data-bs-toggle="tooltip" title="MatchMaking" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="canceled">
                                    <div className="entries-wrapper mb-3 tabs-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <table className="table table-striped table-bordered dataTable no-footer" id="table2" ref={canceledRef}>
                                        <thead>
                                            <tr>
                                                <th>Request ID</th>
                                                <th>Club Director</th>
                                                <th>Club</th>
                                                <th>Team Name</th>
                                                <th>Season</th>
                                                <th>Age Group</th>
                                                <th>Submitted On</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Row 1: Pending */}
                                            <tr>
                                                <td>#REQ-001</td>
                                                <td>
                                                    <span>Alex Morgan</span>
                                                </td>
                                                <td>Riverside FC</td>
                                                <td>Eagles U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 18, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 2: Pending */}
                                            <tr>
                                                <td>#REQ-002</td>
                                                <td>
                                                    <span>Michael Chen</span>
                                                </td>
                                                <td>Metro United</td>
                                                <td>Tigers U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 19, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 3: Pending */}
                                            <tr>
                                                <td>#REQ-003</td>
                                                <td>
                                                    <span>Jessica Rodriguez</span>
                                                </td>
                                                <td>Eagle Sports</td>
                                                <td>Bears U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 20, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 4: Pending */}
                                            <tr>
                                                <td>#REQ-004</td>
                                                <td>
                                                    <span>Sarah Williams</span>
                                                </td>
                                                <td>Panthers CC</td>
                                                <td>Panthers U-10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 24, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-cancelled">Cancelled</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            {/* Row 5: Pending */}
                                            <tr>
                                                <td>#REQ-005</td>
                                                <td>
                                                    <span>David Kim</span>
                                                </td>
                                                <td>North Stars SC</td>
                                                <td>Rockets U10</td>
                                                <td>Spring 2026</td>
                                                <td>U-10</td>
                                                <td>Feb 25, 2026</td>
                                                <td>
                                                    <span className="badge bg-soft-pending">Pending</span>
                                                </td>
                                                <td>
                                                    <ul className="tbl_actions_wrap">
                                                        <li>
                                                            <a href="#" onClick={openMatchmaking}>
                                                                <i className="bx bx-check-circle" title="MatchMaking"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={openCancelModal}>
                                                                <i className="bx bx-trash" title="Cancel" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div className="modal fade" id="cancelModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content" style={{ borderRadius: 20 }}>

                        <div className="modal-header">
                            <h5 className="modal-title">Cancel Request</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div className="modal-body">
                            <p className="fw-semibold">Reason for cancellation</p>

                            <select
                                className="form-select mb-3"
                                onChange={(e) => {
                                    const textarea = e.target.parentNode.querySelector("textarea");
                                    textarea.style.display =
                                        e.target.value === "Other" ? "block" : "none";
                                }}
                            >
                                <option>No eligible opponent available</option>
                                <option>Venue unavailable</option>
                                <option>Season conflict</option>
                                <option>Other</option>
                            </select>

                            <textarea
                                className="form-control"
                                placeholder="Please specify"
                                rows="2"
                                style={{ display: "none" }}
                            ></textarea>
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button className="btn btn-danger" data-bs-dismiss="modal">Confirm Cancellation</button>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal fade" id="matchmakingModal" data-bs-backdrop="static" tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">

                        {/* Header */}
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold">Matchmaking – #REQ-001</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={resetMM}></button>
                        </div>

                        <div className="modal-body p-4">

                            {/* Step Indicator */}
                            <div className="step-indicator mb-4">
                                <span className="step active" id="mmStep1">1. Filter Teams</span>
                                <span className="step" id="mmStep2">2. Select Opponent</span>
                                <span className="step" id="mmStep3">3. Set Details</span>
                                <span className="step" id="mmStep4">4. Confirm</span>
                            </div>

                            {/* STEP 1 */}
                            <div id="mmStep1Content">
                                <div className="mm-header mb-3">
                                    <h5>
                                        Requesting Team: Eagles U10 ·{" "}
                                        <span>Season: Spring 2026 · Age Group: U-10</span>
                                    </h5>
                                </div>

                                <h6 className="fw-bold mb-3">Eligible Opponent Teams</h6>

                                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className="table table-striped table-bordered align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>TEAM NAME</th>
                                                <th>Club Name</th>
                                                <th>CLUB DIRECTOR</th>
                                                <th>AGE GROUP</th>
                                                <th>SEASON</th>
                                                <th>AVAILABLE SLOTS</th>
                                                <th>ACTION</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>Tigers U10</td>
                                                <td>Metro United</td>
                                                <td>Sam Taylor</td>
                                                <td>U-10</td>
                                                <td>Spring 2026</td>
                                                <td>Sat/Sun mornings</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => window.selectOpp("Tigers U10", "Metro United")}
                                                    >
                                                        Select
                                                    </button>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Bears U10</td>
                                                <td>Eagle Sports</td>
                                                <td>Pat Williams</td>
                                                <td>U-10</td>
                                                <td>Spring 2026</td>
                                                <td>Weekday evenings</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => window.selectOpp("Bears U10", "Eagle Sports")}
                                                    >
                                                        Select
                                                    </button>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Rockets U10</td>
                                                <td>North Stars SC</td>
                                                <td>Jamie Chen</td>
                                                <td>U-10</td>
                                                <td>Spring 2026</td>
                                                <td>Flexible</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => window.selectOpp("Rockets U10", "North Stars SC")}
                                                    >
                                                        Select
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* STEP 2 */}
                            <div id="mmStep2Content" style={{ display: "none" }}>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div className="text-center vs-main-box">
                                        <h5 className="fw-bold">Eagles U10</h5>
                                        <p className="mb-0">Riverside FC</p>
                                    </div>

                                    <div className="fw-bold fs-4">VS</div>

                                    <div className="text-center vs-main-box">
                                        <h5 className="fw-bold" id="oppTeamName">Tigers U10</h5>
                                        <p className="mb-0" id="oppClubName">Metro United</p>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between mt-3">
                                    <button className="btn btn-secondary" onClick={window.backToStep1}>
                                        ← Back
                                    </button>
                                    <button className="btn btn-primary" onClick={window.goToStep3}>
                                        Confirm & Set Details →
                                    </button>
                                </div>
                            </div>

                            {/* STEP 3 */}
                            <div id="mmStep3Content" style={{ display: "none" }}>
                                <div className="row g-3 mb-3">

                                    <div className="col-md-6">
                                        <label className="form-label">Venue Name</label>
                                        <input className="form-control" placeholder="Enter venue name" />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Venue Location</label>
                                        <input className="form-control" placeholder="Enter venue location" />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Match Date</label>
                                        <input type="date" className="form-control" />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Match Time</label>
                                        <input type="time" className="form-control" />
                                    </div>

                                </div>

                                <div className="d-flex justify-content-between mt-3">
                                    <button className="btn btn-secondary" onClick={window.backToStep2}>
                                        ← Back
                                    </button>
                                    <button className="btn btn-primary" onClick={window.goToStep4}>
                                        Schedule Match →
                                    </button>
                                </div>
                            </div>

                            {/* STEP 4 */}
                            <div id="mmStep4Content" style={{ display: "none" }}>
                                <div className="confirmation-box text-center">
                                    <i className="bx bx-check-circle fs-1 text-success"></i>
                                    <h4 className="mt-2 fw-bold">Match Scheduled!</h4>
                                    <p>
                                        Both club directors have been notified. A game record has been created.
                                    </p>
                                </div>

                                <div className="d-flex justify-content-between mt-3">
                                    <button className="btn btn-secondary" onClick={window.backToStep3}>
                                        ← Back
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        data-bs-dismiss="modal"
                                        onClick={resetMM}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default GameMatchmaking